import { RuleId } from '@wix/a11y-rules';
import { isOptional } from '@wix/seo-common-core';
import { normalizeElementKey } from './normalize-element-key';
export const getCrossColorContrastIssuesByBreakpoint = (getIsComponentInGlobalSection, results, enableGlobalSectionForIncompleteElements) => {
  const pageEntries = Object.values(results);
  const [firstPageResults, ...otherPages] = pageEntries;
  if (!firstPageResults || !firstPageResults[RuleId.COLOR_CONTRAST]) {
    return null;
  }
  const crossIssuesByBreakpoint = {};
  for (const firstResultRaw of firstPageResults[RuleId.COLOR_CONTRAST]) {
    var _firstResult$metadata, _firstResult$result;
    const firstResult = firstResultRaw;
    const breakpointId = firstResult == null || (_firstResult$metadata = firstResult.metadata) == null ? void 0 : _firstResult$metadata.breakpointId;
    if (!breakpointId) {
      continue;
    }
    if (isOptional((_firstResult$result = firstResult.result) == null ? void 0 : _firstResult$result.failedElements)) {
      console.error(`Color contrast element has no failedElements for breakpoint ${breakpointId}`);
      return null;
    }
    const otherKeySets = otherPages.map(page => {
      var _match$result;
      const match = ((page == null ? void 0 : page[RuleId.COLOR_CONTRAST]) ?? []).find(r => {
        var _r$metadata;
        return (r == null || (_r$metadata = r.metadata) == null ? void 0 : _r$metadata.breakpointId) === breakpointId;
      });
      return new Set(((match == null || (_match$result = match.result) == null ? void 0 : _match$result.failedElements) ?? []).map(normalizeElementKey));
    });
    const isShared = el => {
      const key = normalizeElementKey(el);
      return (enableGlobalSectionForIncompleteElements || !el.isIncomplete) && (getIsComponentInGlobalSection(el.elementId) || otherKeySets.every(keySet => keySet.has(key)));
    };
    const sharedFailedElements = firstResult.result.failedElements.filter(el => isShared(el));
    crossIssuesByBreakpoint[breakpointId] = {
      ...firstResult,
      result: {
        ...firstResult.result,
        failedElements: sharedFailedElements,
        status: sharedFailedElements.length === 0 ? 'passed' : firstResult.result.status
      }
    };
  }
  return Object.keys(crossIssuesByBreakpoint).length > 0 ? crossIssuesByBreakpoint : null;
};
//# sourceMappingURL=get-cross-color-contrast-issues-by-breakpoint.js.map